import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { LogService } from 'src/app/services/common/log.service';
import { HelperService } from 'src/app/shared/helpers/helper.service';
import { environment } from 'src/environments/environment';
import { IdentitableButtonEnum } from '../subscription-tables/desktop/subscription-table-desktop.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargeReasonModalComponent } from 'src/app/pages/charge-reason-modal/charge-reason-modal.component';
import { ProductLevel } from '../product-hero/product-hero.component';
import { ProductType, User } from 'src/app/interfaces/user';
import { MemberShipOptionsService } from 'src/app/services/membership-options/membership-options.service';
import { UserService } from 'src/app/services/user/user.service';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { isPlatformBrowser } from '@angular/common';
import { ConfigService } from '../../../../services/config/config.service';
import { PaymentConfigService } from 'src/app/services/payment-config/payment-config.service';

@Component({
  selector: 'app-identibase-plus-page',
  templateUrl: './identibase-plus-page.component.html',
  styleUrls: ['./identibase-plus-page.component.scss'],
})
export class IdentibasePlusPageComponent implements OnInit, OnDestroy {
  public pricingPlans = environment.stripePlans;
  public IdentitableButtonEnum = IdentitableButtonEnum;
  public desktopViewVisible: boolean;
  public buyButtonVisible: boolean = true;
  public user: User;
  public hasIdentibasePlusOption: boolean;
  public hasIdentiAlertOption: boolean;
  public isAuthenticated: boolean;
  public isBrowser: boolean;

  private _subs: Subscription[] = [];
  public productLevels = ProductLevel;
  public plan1Name = this.configService.getTextFromKey('1-plan-name');
  public plan2Name = this.configService.getTextFromKey('2-plan-name');
  public plan2Route: string;
  public plan2YearlyPrice: string;
  public plan1FeatureText1: string;
  public plan1FeatureText2: string;
  public plan1FeatureText3: string;
  public plan1FeatureText4: string;
  public plan2FeatureText1: string;
  public plan2FeatureText2: string;
  public plan2FeatureText3: string;
  public plan2FeatureText4: string;
  public heroSubtitle: string;

  constructor(
    private _checkoutService: CheckoutService,
    private _logService: LogService,
    private _router: Router,
    private _helperService: HelperService,
    private _modalService: NgbModal,
    private route: ActivatedRoute,
    private membershipOptionsService: MemberShipOptionsService,
    private userService: UserService,
    private authManager: AuthManagerService,
    private configService: ConfigService,
    private paymentConfigService: PaymentConfigService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.plan2Route = this.configService.getTextFromKey('2-plan-route');
    this.plan2YearlyPrice = this.configService.getTextFromKey('2-plan-yearly-price');
    this.plan2YearlyPrice =
      this.paymentConfigService.getYearlyDisplayPrice(ProductType.Premium) ?? this.plan2YearlyPrice;
    this.plan1FeatureText1 = this.configService.getTextFromKey('1-plan-feature-text-1');
    this.plan1FeatureText2 = this.configService.getTextFromKey('1-plan-feature-text-2');
    this.plan1FeatureText3 = this.configService.getTextFromKey('1-plan-feature-text-3');
    this.plan1FeatureText4 = this.configService.getTextFromKey('1-plan-feature-text-4');
    this.heroSubtitle = this.configService.getTextFromKey('1-plan-page-hero-subtitle-text');
  }

  ngOnInit() {
    this.isAuthenticated = this.authManager.isAuthenticated;
    if (this.isAuthenticated) {
      this.userService.getMe().subscribe((userResponse: User) => {
        this.user = userResponse;
        this.hasIdentibasePlusOption = this.membershipOptionsService.identiBasePlusAvailable(this.user);
        this.hasIdentiAlertOption = this.membershipOptionsService.identiAlertAvailable(this.user);
      });
    }

    if (this.isBrowser) {
      const currentUrl = window.location.search;
      const params = new URLSearchParams(currentUrl);
      const learnValue = params.get('learn')
      if (learnValue !== null && learnValue.toLowerCase() === 'true') {
        this.buyButtonVisible = false;
      }
    }
  }

  ngOnDestroy() {
    this._subs.forEach((it) => it.unsubscribe());
  }

  public buyIdentibasePlusSubscription() {
    const planId = this.pricingPlans.identibasePlus;
    this._checkoutService.checkout([planId]).subscribe(
      () => {
        // Nothing should happen here because if checkout gets completed successfully, a redirect
        // will be triggered by stripe checkout
      },
      (err) => {
        this._logService.error('an error occured: ', err);
      }
    );
  }

  public buyIdentiAlertSubscription() {
    const planId = this.pricingPlans.identiAlertAnnual;
    this._checkoutService.checkout([planId]).subscribe(
      () => {
        // Nothing should happen here because if checkout gets completed successfully, a redirect
        // will be triggered by stripe checkout
      },
      (err) => {
        this._logService.error('an error occured: ', err);
      }
    );
  }

  public compareClick() {
    this._helperService.scrollToElementById('subscription-table');
  }

  public navigateToIdentialertPage() {
    this._router.navigate([this.plan2Route]);
  }

  public onIdentitableButtonClicked(buttonClickedName: string) {
    switch (buttonClickedName) {
      case IdentitableButtonEnum.IdentibasePlusButton:
        this.buyIdentibasePlusSubscription();
        break;
      case IdentitableButtonEnum.IdentialertButton:
        this.navigateToIdentialertPage();
        break;
    }
  }

  public openChargeModal() {
    this._modalService.open(ChargeReasonModalComponent);
  }

}
